import { Icon, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// Muted, non-interactive block: this restates the fan's own signup answer, so it has to read as
// a record rather than as a form control an admin can toggle.
const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0 0;
  padding: 12px 14px;
  border-radius: 8px;
  background: ${theme.GREY_10};
  cursor: default;
  user-select: none;
`;

const Box = styled.div`
  width: 18px;
  height: 18px;
  min-width: 18px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.checked ? theme.SECONDARY : theme.PRIMARY_WHITE)};
  border: 1.5px solid ${(props) => (props.checked ? theme.SECONDARY : theme.GREY_30)};
`;

/**
 * Mirrors the signup checkbox so an admin sees what the fan actually saw: filled and ticked if
 * they agreed, empty if they declined. Read-only — consent is the fan's own answer, never an
 * admin's to set.
 *
 * Renders nothing when the field is absent, which means the account predates the checkbox and was
 * never asked. Absent is not a decline, so it must not show as an empty box.
 */
const SponsorConsent = ({ user }) => {
  const { t } = useTranslation();

  if (typeof user?.sponsorConsent !== 'boolean') return null;

  const checked = user.sponsorConsent;

  return (
    <Container title={t('admin.readOnlyField')}>
      <Box checked={checked}>
        {checked && <Icon type="check" dimensions={12} col={theme.PRIMARY_WHITE} />}
      </Box>

      <Text b2 col={theme.GREY_60} marg="0 0 0 12px">
        {t('auth.sponsorConsent')}
      </Text>
    </Container>
  );
};

export default SponsorConsent;
